'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Img = require('../../01.atoms/Img/Img.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-image',
    cnSubline = "".concat(CLASSNAME, "__subline");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function Image(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      lazy = _ref.lazy,
      srcset = _ref.srcset,
      subline = _ref.subline;

  if (!srcset) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className)
  }, /*#__PURE__*/React__default.createElement(Img, {
    srcset: srcset,
    alt: alt,
    lazy: lazy
  }), subline && /*#__PURE__*/React__default.createElement("div", {
    className: cnSubline
  }, subline));
}
Image.propTypes = {
  /** Alt text */
  alt: PropTypes.string,

  /** Additional class name */
  className: PropTypes.string,

  /** True for lazy loading */
  lazy: PropTypes.bool,

  /** Images in different sizes */
  srcset: PropTypes.shape({
    xs: PropTypes.string.isRequired,
    sm: PropTypes.string,
    md: PropTypes.string,
    lg: PropTypes.string,
    xl: PropTypes.string,
    xxl: PropTypes.string
  }).isRequired,

  /** Optional subline under image */
  subline: PropTypes.string
};

module.exports = Image;
